/* eslint-disable object-curly-newline */
/* eslint-disable max-len */

import { CareerResultsItem } from "../api/SearchCareerClassListService";
import { CAREER_TYPE_ELEARNING } from "../../Constants";
import { currentDate, DateFormats, diffDay, parseJSDate } from "../datetime";

const ALERT_VIEW_DAYS = 7;

export const alertDaysForSearchCareer = (career: CareerResultsItem) => {
    if (String(career.careerTypeId) !== CAREER_TYPE_ELEARNING) return { alertView: false };
    const targetDate = parseJSDate(career.endDate, DateFormats.YYYYMMDDHHMMSS_WITH_OFFSET);
    if (!targetDate) return { alertView: false };
    const today = currentDate();
    const diffDays = diffDay(targetDate, today);
    const deadlineAlertView = diffDays >= 0 && diffDays <= ALERT_VIEW_DAYS && !Number.isNaN(diffDays);
    return { alertView: deadlineAlertView, remainingDays: diffDays };
};
